<template>
  <Navbar :center-text="$t('SuccessStoriesView.successStories')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>

  <div class="container mt-4">
    <div class="row">
      <div v-for="entry in files"
           class="col-sm-12 col-md-6 col-lg-5 mx-1 mb-4 cards-container justify-content-center align-items-center">
        <div :class="`card card-${entry.card_color} text-center shadow-sm`">
          <div class="card-body">
            <h5 class="card-title">
              <i class="bi bi-file-post"></i>
              {{entry.title}}
            </h5>
            <p class="card-text">
              <embed :src="`https://canalls.uni-hohenheim.de/backend/index.php/documents/${entry.file_id}`"
                      style="width:100%; height:650px;" />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {getAllSuccessStories} from "@/utils";

export default {
  components: {Footerbar, Navbar},
  data() {
    return {
      message: null,
      messageType: null,
      files: []
    }
  },
  async mounted() {
    let storiesResponse = await getAllSuccessStories();
    if(storiesResponse.status === 200) {
      this.files = storiesResponse.data;
    } else {
      this.message = storiesResponse.response.data.message;
      this.messageType = 'danger';
    }
  }
}
</script>